import useVerificationCode from '../../../es/_hooks/useVerificationCode';
export default useVerificationCode;
